// API status codes: 0=Completed, 1=Queued, 4=Processing, 20=Errored, 21=Cancelled.
const OrderStatuses = {
    0: { displayedName: 'Completed' },
    1: { displayedName: 'Queued' },
    4: { displayedName: 'Processing' },
    20: { displayedName: 'Errored' },
    21: { displayedName: 'Cancelled' },
};

export const ACTIVE_ORDER_LABEL = 'Active';

/**
 * A Queued (1) order that already has an uploadOrderID is displayed as Active.
 * Every other status, or a Queued order without one, keeps its normal label.
 */
export const isActiveOrder = (status, uploadOrderID) =>
    Number(status) === 1 && Boolean(uploadOrderID);

export default OrderStatuses;
